import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const StatusContext = createContext({ byKey: {}, list: [], loading: true });
export const useStatuses = () => useContext(StatusContext);

export function StatusProvider({ children }) {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!user || user.is_platform) { setLoading(false); return; }
    api.get("/ticket-statuses").then((r) => setList(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [user]);
  const byKey = Object.fromEntries(list.map((s) => [s.key, s]));
  return <StatusContext.Provider value={{ byKey, list, loading }}>{children}</StatusContext.Provider>;
}
